<template>
  <div>
    <v-layout row wrap mb-1>
      <v-flex lg3>
        <p class="headline mt-2">
          Pagos
        </p>
      </v-flex>
      <v-flex lg2 pl-3>
        <v-select
          v-model="type"
          :items="graphicTypes"
          color="grey"
          solo>
        </v-select>
      </v-flex>
      <v-flex lg3 pl-3>
        <v-select
          v-model="filters.channel"
          :items="channels"
          color="grey"
          solo>
        </v-select>
      </v-flex>
      <v-flex lg2 pl-3>
        <v-menu
          ref="toPicker"
          :close-on-content-click="true"
          :nudge-right="40"
          :return-value.sync="filters.date"
          transition="scale-transition"
          min-width="290px"
          lazy
          offset-y
          full-width>
          <v-text-field
            slot="activator"
            :value="formatDate(filters.date, filters.type === 'monthly' ? 'YYYY-MM' : 'YYYY-MM-DD', filters.type === 'monthly' ? 'MM/YYYY' : 'DD/MM/YYYY')"
            class="k-orange-linear-text"
            prepend-icon="event"
            readonly
            solo>
          </v-text-field>
          <v-date-picker
            v-model="filters.date"
            @input="$refs.toPicker.save(filters.date)"
            locale="es"
            :type="filters.type === 'monthly' ? 'month' : 'date'"
            color="k-orange-linear">
          </v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex lg2 pl-3 mb-2>
        <v-btn large block class="h-100 ma-0 white" @click="filter()">
          <v-icon>filter_list</v-icon>
          Filtrar
        </v-btn>
      </v-flex>
    </v-layout>
    <graphics
      graphic-id-one="totalsGraphic"
      graphic-id-two="sendsGraphic"
      :filters="filters"
      url="notification_customers"
    ></graphics>
    <sidebar title="Filtrar" :bus="sidebarBus" :delete-filters-button="true">
      <template slot="content">
        <v-layout row wrap>
          <v-flex md6 pl-4>
            <v-menu
              ref="toPickerDueDate"
              :close-on-content-click="true"
              :nudge-right="40"
              :return-value.sync="due_date"
              transition="scale-transition"
              min-width="290px"
              lazy
              offset-y
              full-width>
              <v-text-field
                label="Fecha vencimiento"
                slot="activator"
                :value="formatDate(due_date, 'YYYY-MM-DD', 'DD/MM/YYYY')"
                color="grey"
                readonly>
              </v-text-field>
              <v-date-picker
                v-model="due_date"
                @input="$refs.toPickerDueDate.save(due_date)"
                locale="es"
                color="k-orange-linear">
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex md6 pl-4>
            <v-select
              v-model="tranche"
              :items="trMorasList"
              color="grey">
            </v-select>
          </v-flex>
          <v-flex md6 pl-4>
            <v-select
              v-model="portfolio_type"
              :items="pursesList"
              color="grey">
            </v-select>
          </v-flex>
          <v-flex md6 pl-4>
            <v-select
              v-model="agency"
              :items="agencies"
              item-text="name"
              item-value="agency_code"
              color="grey">
            </v-select>
          </v-flex>
        </v-layout>
      </template>
    </sidebar>
  </div>
</template>

<script>
import EventBus from '@/event-bus';
import moment from 'moment';
import reportsListMixin from '@/mixins/reportsList';
import sidebar from '@/components/global/Sidebar';
import graphics from '@/components/panel/payment_smy/Graphics';

export default {
  mixins: [
    reportsListMixin,
  ],
  components: {
    graphics,
    sidebar,
  },
  props: ['date'],
  data() {
    return {
      filters: {
        channel: 'sms',
        date: moment().format('YYYY-MM-DD'),
        tranche: '',
        type: 'daily',
        portfolio_type: '',
        due_date: '',
        agency: '',
      },
      type: 'daily',
      tranche: '',
      portfolio_type: '',
      agency: '',
      due_date: moment().format('YYYY-MM-DD'),
      graphicTypes: [
        {
          text: 'Mensual',
          value: 'monthly',
        },
        {
          text: 'Diario',
          value: 'daily',
        },
      ],
      sidebarBus: {
        open: 'openNotificationCustomerSidebar',
        close: 'closeNotificationCustomerSidebar',
        apply: 'applyNotificationCustomerSidebarFilters',
        unapply: 'unapplyNotificationCustomerSidebarFilters',
      },
      channels: [
        {
          text: 'SMS',
          value: 'sms',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: 'IVR',
          value: 'ivr',
        },
        {
          text: 'BOT',
          value: 'bot',
        },
        {
          text: 'Call Center',
          value: 'human',
        },
      ],
      agencies: [],
    };
  },
  mounted() {
    EventBus.$on(this.sidebarBus.apply, () => {
      this.filters.tranche = this.tranche;
      this.filters.portfolio_type = this.portfolio_type;
      this.filters.agency = this.agency;
      this.filters.due_date = this.due_date;
      EventBus.$emit(this.sidebarBus.close);
    });
    EventBus.$on(this.sidebarBus.unapply, () => {
      this.filters.tranche = '';
      this.filters.portfolio_type = '';
      this.filters.agency = '';
      this.filters.due_date = '';
      this.tranche = '';
      this.portfolio_type = '';
      this.agency = '';
      this.due_date = moment().format('YYYY-MM-DD');
      EventBus.$emit(this.sidebarBus.close);
    });
    this.axios.get('agencies?paginate=0').then((response) => {
      this.agencies = response.data;
      this.agencies.unshift({
        name: 'Agencias',
        agency_code: '',
      });
    }).catch(() => { });
  },
  methods: {
    formatDate(date, typeFormat, toFormat) {
      return moment(date, typeFormat).format(toFormat);
    },
    filter() {
      EventBus.$emit(this.sidebarBus.open);
    },
  },
  watch: {
    type(val) {
      this.filters.type = val;
    },
    'filters.type'(val) { // eslint-disable-line
      if (val === 'daily') {
        this.filters.date = moment().format('YYYY-MM-DD');
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/panel/payment_smy/Index.vue